import { render, staticRenderFns } from "./WXLoginComponent.vue?vue&type=template&id=5efea7c8&scoped=true&"
import script from "./WXLoginComponent.vue?vue&type=script&lang=js&"
export * from "./WXLoginComponent.vue?vue&type=script&lang=js&"
import style0 from "./WXLoginComponent.vue?vue&type=style&index=0&id=5efea7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efea7c8",
  null
  
)

export default component.exports